export enum Status {
  progress = 'IN PROGRESS',
  pending = 'PENDING'
}